import { Dialog, DialogContent, DialogHeader, DialogTitle } from 'src/shared/components/ui/popups/dialog'
import type { PublicUserData } from 'src/shared/features/users/schemas/user'

interface BioModalProps {
  isOpen: boolean
  setOpen: (open: boolean) => void
  user: PublicUserData
}

export default function BioModal({ isOpen, setOpen, user }: BioModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={setOpen}>
      <DialogContent className="w-[500px] max-w-[90vw] rounded-[20px] px-5 py-6 sm:rounded-[20px] md:px-[25px] md:py-[36px]">
        <DialogHeader>
          <DialogTitle className="mb-4 text-[26px] font-bold">About {user.fullName}</DialogTitle>
        </DialogHeader>
        <p className="whitespace-pre-wrap text-[15px] text-muted md:text-[16px]">{user.biography}</p>
      </DialogContent>
    </Dialog>
  )
}
